import type { IUser } from '@/models/auth';

const AUTH_STORAGE_KEYS = [
  'AccessToken',
  'isAuthenticated',
  'user',
  'sessionStart',
] as const;

/** Removes persisted auth tokens and user snapshot from localStorage. */
export function clearClientAuthStorage(): void {
  try {
    AUTH_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key));
  } catch {
    /* storage unavailable */
  }
}

/**
 * Best-effort server logout + clear local session (no navigation).
 * Shared by interactive logout and forced logout (e.g. inactivity).
 */
export function performClientLogout(
  logoutApi: () => Promise<unknown>,
  setUser: (user: IUser | null) => void
): void {
  logoutApi().catch(() => {});
  clearClientAuthStorage();
  setUser(null);
}
